import { MaterialCreationProcess, MaterialOrigin } from 'api';

const MATERIAL_CREATION_PROCESS_MAP = {
  [MaterialCreationProcess.HAND_PICKED]: 'Hand picked',
  [MaterialCreationProcess.MECHANICAL]: 'Mechanical',
};

export const formatMaterialCreationProcess = (process: MaterialCreationProcess) => {
  return MATERIAL_CREATION_PROCESS_MAP[process];
};

export const formatMaterialOrigin = (origin: MaterialOrigin['type']) => {
  return String(origin).charAt(0).toUpperCase() + String(origin).slice(1);
};
